export const retentionLabel = data => data?.export_version === 2 ? 'RETENCIÓN USD' : 'RETENCIÓN';
export const retentionConversion = data => data?.export_version === 2
  ? 'normalizado por fecha; Excel en ratio de cada unión'
  : data?.usd_ratios ? `PPSR /${data.usd_ratios.PPSR} + PPST /${data.usd_ratios.PPST}` : `Retención /${data?.usd_divisor || 6}`;
